export class ArtistProfileForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.submit = this.querySelector('[data-ref="submit"]');
    this.loading = this.querySelector('[data-ref="loading"]');
    this.fields = this.querySelectorAll('[data-original-value]');
    this.cancelButton = this.querySelector('[data-ref="cancelButton"]');
  }

  connectedCallback() {
    this.form.addEventListener('submit', (event) => {
      this.submitArtistForm(event);
    });

    console.log(this.cancelButton);
    if (this.cancelButton) {
      this.cancelButton.addEventListener('click', () => {
        this.resetFields();
      });
    }
  }

  async uploadFile(file, fieldKey, id) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fieldKey', fieldKey);

    if (id) {
      formData.append('id', id);
    }

    const response = await fetch('https://spindle-forms.vercel.app/metaobject/upload-file', {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      const contentType = response.headers.get('content-type') || '';
      let message = 'Upload failed';

      if (contentType.includes('application/json')) {
        const error = await response.json();
        message = error.error || message;
      } else {
        const text = await response.text();
        message = text || message;
      }

      throw new Error(message);
    }

    return response.json();
  }

  async updateMetaobject(id, fields) {
    const response = await fetch('https://spindle-forms.vercel.app/metaobject/update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id, fields })
    });

    const payload = await response.json();

    if (!response.ok) {
      const message =
        payload.error ||
        (Array.isArray(payload.errors)
          ? payload.errors
              .map((err) => err.message || JSON.stringify(err))
              .join('; ')
          : 'Metaobject update failed');

      throw new Error(message);
    }

    return payload;
  }

  async submitArtistForm(event) {
    event.preventDefault();

    this.submit.disabled = true;
    this.loading.classList.remove('hidden');

    const form = event.currentTarget;
    const formData = new FormData(form);
    const id = formData.get('id');
    const file = formData.get('profileImage');
    const fieldKey = 'artist_image';

    const hueValue = Number(formData.get('hue'));
    const hue = Number.isFinite(hueValue) ? hueValue : 50;
    const profilePrimaryColor = this.hsl2hex(hue, 45, 25, 1);

    try {
      let uploadResult = null;

      if (file instanceof File && file.size > 0) {
        uploadResult = await this.uploadFile(file, fieldKey, id);
      }

      const fields = [
        { key: 'location', value: formData.get('field[location]') },
        { key: 'genre', value: formData.get('field[genre]') },
        { key: 'biography', value: formData.get('field[biography]') },
        { key: 'profile_primary_colour', value: profilePrimaryColor }
      ].filter(({ value }) => value != null && value !== '');

      let result = null;

      if (fields.length > 0) {
        result = await this.updateMetaobject(id, fields);
      } else if (uploadResult?.metaobject) {
        result = { metaobject: uploadResult.metaobject };
      } else {
        result = { metaobject: null };
      }

      console.log('Updated metaobject:', result.metaobject ?? result);

      for(const field of this.fields) {
        field.setAttribute('data-updated', true);
      }

      this.submit.disabled = false;
      this.loading.classList.add('hidden');
      window.location.reload();
    } catch (err) {
      console.error('Submit failed', err);
      this.submit.disabled = false;
      this.loading.classList.add('hidden');
    }
  }

  resetFields() {
    if (this.fields) {
      for (const field of this.fields) {
        console.log(field, field.getAttribute('data-original-value'));
        field.value = field.getAttribute('data-original-value');
        setHue();
      }
    }
  }

  hsl2hex(h, s, l) {
    l /= 100;
    const a = s * Math.min(l, 1 - l) / 100;
    const f = (n) => {
      const k = (n + h / 30) % 12;
      const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
      return Math.round(255 * color).toString(16).padStart(2, '0');
    };

    return `#${f(0)}${f(8)}${f(4)}`;
  }
}